/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from 'react';

import styled from 'styled-components';

import {ActionButton, ActionButtonSecondary} from 'screens/commons';
import {Nominee} from './content';

const Optional = ({isLoading, handleSkip, handleSkipStep}) => {
  const activeContent = Nominee;

  return (
    <OptionalWrapper>
      <Container>
        <Title className="body-regular">{activeContent.title}</Title>
        {activeContent.subtext ? (
          <SubHeader className="body-regular">{activeContent.subtext}</SubHeader>
        ) : null}
        <Description
          className="body-regular"
          dangerouslySetInnerHTML={{__html: activeContent.description}}
        />
        <ButtonWrapper>
          <ActionButton
            buttonText="Add nominee"
            callback={() => handleSkipStep(1)}
            isLoading={isLoading}
          />
          <ActionButtonSecondary
            buttonText={`I don't wish to nominate now`}
            callback={handleSkip}
            isDisabled={isLoading}
          />
        </ButtonWrapper>
      </Container>
    </OptionalWrapper>
  );
};

const OptionalWrapper = styled.div`
  width: 100%;
  height: 100%;
  scroll-behavior: scroll;
  position: relative;

  @media (max-width: 768px) {
    background: #fff;
    height: 100%;
  }
`;

const Container = styled.div`
  width: 90%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
`;

const ButtonWrapper = styled.div`
  margin: 8rem 0 0 0;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const Title = styled.h1`
  margin: 0;
  padding: 0;
`;

const SubHeader = styled.p.attrs({})`
  margin: 1rem 0;
  padding: 0;
  color: #7e7e7e;
  text-align: justify;
`;

const Description = styled(SubHeader)`
  margin-top: 0;
  ul {
    padding-left: 0;
    margin: 1.5rem 0;
    list-style: none;
  }

  li {
    position: relative;
    padding-left: 1.5rem;
    margin-bottom: 1rem;
    line-height: 1.6;

    &:before {
      content: '•';
      position: absolute;
      left: 0;
      color: #333;
      font-weight: bold;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul ul {
    margin: 0.75rem 0;
    padding-left: 1rem;

    li {
      margin-bottom: 0.5rem;
      font-size: 0.95em;

      &:before {
        content: '◦';
        color: #666;
      }
    }
  }

  b {
    font-weight: 600;
    color: #333;
  }
`;

export default Optional;
